import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class GungStringConverterService {
  private static readonly toGungCharTestRegExp = /[\/#.+&]/;
  private static readonly toGungCharRegExp = /[\/#.+&]/g;
  private static readonly toGungTokenMap: { [token: string]: string } = {
    '/': '_GUNGSLASH_',
    '#': '_GUNGHASH_',
    '.': '_GUNGDOT_',
    '+': '_GUNGPLUS_',
    '&': '_GUNGAMP_'
  };
  private static readonly fromGungTokenRegExp = /_GUNG(?:SLASH|HASH|DOT|PLUS|AMP)_/g;
  private static readonly fromGungTokenMap: { [token: string]: string } = {
    _GUNGSLASH_: '/',
    _GUNGHASH_: '#',
    _GUNGDOT_: '.',
    _GUNGPLUS_: '+',
    _GUNGAMP_: '&'
  };

  constructor() {}

  public static toGungString(str: string): string {
    if (!GungStringConverterService.toGungCharTestRegExp.test(str)) {
      return str;
    }

    return str.replace(GungStringConverterService.toGungCharRegExp, token => GungStringConverterService.toGungTokenMap[token]);
  }

  public static fromGungString(str: string): string {
    if (str?.indexOf('_GUNG') === -1) {
      return str;
    }

    return str?.replace(GungStringConverterService.fromGungTokenRegExp, token => GungStringConverterService.fromGungTokenMap[token]);
  }
}
